// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_PeriodInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Shared query-string input for period-scoped GET endpoints.
 *
 * Optional:
 *   period (string|null) — YYYY-MM period filter. Defaults to current month when absent.
 */
import { registerContract } from './validate'

export interface AiCredits_PeriodInput {
period?: string
}

registerContract('AiCredits_PeriodInput', {
  period: { type: 'string',  required: false },
})
